import { CareerMap, Chapter } from '../../typesV2';

const getActiveSubtopicIndexes = ({
  mapData,
  chapter,
  contentSlug
}: {
  mapData: CareerMap,
  chapter?: Chapter,
  contentSlug: string
}): Chapter => {
  if (chapter) {
    return chapter;
  }

  // Search through each topic in the career map
  for (let topicIndex = 0; topicIndex < mapData.topicList.length; topicIndex++) {
    const topic = mapData.topicList[topicIndex];

    // Check sections
    if (topic.sections) {
      const sectionIndex = topic.sections.findIndex(section => section.slug === contentSlug);
      if (sectionIndex !== -1) {
        return {
          type: 'section',
          topicIndex,
          subtopicIndex: sectionIndex
        };
      }
    }

    // Check options
    if (topic.options) {
      const optionIndex = topic.options.findIndex(option => option.slug === contentSlug);
      if (optionIndex !== -1) {
        return {
          type: 'option',
          topicIndex,
          subtopicIndex: optionIndex
        };
      }
    }

    // Check sidequests
    if (topic.sideQuests) {
      const sidequestIndex = topic.sideQuests.findIndex(sidequest => sidequest.slug === contentSlug);
      if (sidequestIndex !== -1) {
        return {
          type: 'sidequest',
          topicIndex,
          subtopicIndex: sidequestIndex
        };
      }
    }
  }

  // If no match is found, return overview type
  return {
    type: 'overview'
  };
}

export default getActiveSubtopicIndexes;
